import React from "react";
import { logOut } from "../../../../../../../components/Logout";
import { handleGetLocal } from "../../../../../../../services/auth-service";
import axios from "axios";

const VoidAlertPopup = ({
  setVoidAlertPopup,
  setLoading,
  navigate,
  setToastConfig,
  toastConfig,
  refreshApi,
  apipayload,
  apiUrl,
  typePara,
}) => {
  const pathname = handleGetLocal("pathURL");

  const handleSave = async () => {
    if (apipayload) {
      setLoading(true);
      await axios
        .post(`${process.env.REACT_APP_API_URL}/${apiUrl}`, apipayload, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            Domain: `${pathname}`,
          },
        })
        .then((val) => {
          setLoading(false);
          if (val?.data?.isSuccess) {
            setVoidAlertPopup(false);
            setToastConfig({
              ...toastConfig,
              isVisible: true,
              message: val?.data?.responseMessage,
              type: val?.data?.responseIcon?.toLowerCase(),
            });
            setTimeout(() => {
              setToastConfig({
                ...toastConfig,
                isVisible: false,
                message: val?.data?.responseMessage,
                type: val?.data?.responseIcon?.toLowerCase(),
              });
            }, 1900);
            refreshApi();
          } else {
            setToastConfig({
              ...toastConfig,
              isVisible: true,
              message: "Error",
              type: "error",
            });
            setTimeout(() => {
              setToastConfig({
                ...toastConfig,
                isVisible: false,
                message: "Error",
                type: "error",
              });
            }, 1900);
          }
        })
        .catch((val) => {
          setLoading(false);
          if (val?.response?.status === 401) {
            logOut();
          } else {
            if (val?.response?.status) {
              navigate(`/error/500`);
            } else {
              navigate("/error/500");
            }
          }
        });
    }
  };

  return (
    <>
      <div className="void-alert-popup">
        <div className="popup_header">
          <div className="popup_header_title">
            <div class="popup_header_title_data">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g id="warning">
                  <path
                    id="Vector"
                    d="M4.47012 20.9997H19.5301C21.0701 20.9997 22.0301 19.3297 21.2601 17.9997L13.7301 4.98969C12.9601 3.65969 11.0401 3.65969 10.2701 4.98969L2.74012 17.9997C1.97012 19.3297 2.93012 20.9997 4.47012 20.9997ZM12.0001 13.9997C11.4501 13.9997 11.0001 13.5497 11.0001 12.9997V10.9997C11.0001 10.4497 11.4501 9.99969 12.0001 9.99969C12.5501 9.99969 13.0001 10.4497 13.0001 10.9997V12.9997C13.0001 13.5497 12.5501 13.9997 12.0001 13.9997ZM13.0001 17.9997H11.0001V15.9997H13.0001V17.9997Z"
                    fill="#ffff"
                  />
                </g>
              </svg>
              <p>Void</p>
            </div>
            <p class="popup_header_title_para">VD.1</p>
          </div>
          <svg
            onClick={() => {
              setVoidAlertPopup(false);
            }}
            style={{
              cursor: "pointer",
            }}
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.72406 0.282539C9.43156 -0.00996077 8.95906 -0.00996077 8.66656 0.282539L4.99906 3.94254L1.33156 0.275039C1.03906 -0.0174609 0.566563 -0.0174609 0.274063 0.275039C-0.0184375 0.567539 -0.0184375 1.04004 0.274063 1.33254L3.94156 5.00004L0.274063 8.66754C-0.0184375 8.96004 -0.0184375 9.43254 0.274063 9.72504C0.566563 10.0175 1.03906 10.0175 1.33156 9.72504L4.99906 6.05754L8.66656 9.72504C8.95906 10.0175 9.43156 10.0175 9.72406 9.72504C10.0166 9.43254 10.0166 8.96004 9.72406 8.66754L6.05656 5.00004L9.72406 1.33254C10.0091 1.04754 10.0091 0.567539 9.72406 0.282539Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="popup-container-data">
          <p className="container-fields-heading">
            Are you sure? you want to {typePara}
          </p>
          <div className="popup_buttons">
            <button className="btn primary_btn" onClick={handleSave}>
              Yes
            </button>
            <button
              className="btn"
              onClick={() => {
                setVoidAlertPopup(false);
              }}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default VoidAlertPopup;
